import { Fragment } from "react";
import { FormProvider } from "../FormContext";
import { useParams } from "react-router-dom";
import ServiceSwitch from "../../components/ServiceSwitch";

const DeliveryFormWrapper = () => {
    const { type } = useParams();

    return <Fragment>
        <FormProvider type={type}>
            <ServiceSwitch type={type} />
        </FormProvider>
    </Fragment>
}

export default DeliveryFormWrapper;